/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable promise/catch-or-return */

import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H2 from 'UIComponents/elements/headings/H2';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UIPanel from 'UIComponents/panel/UIPanel';
import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import UIPanelFooter from 'UIComponents/panel/UIPanelFooter';
import UIPanelHeader from 'UIComponents/panel/UIPanelHeader';
import ConversationsTaxonomy from '../components/ConversationsTaxonomy';
import Track from '../../shared/utils/trackers/ZorseCrmComponentsTracker';
import { closeThread, fetchPropertiesMeta, fetchPropertiesForThread, markThreadAsGhosted, resolveUpdatePropertyError, setPropertyForThread } from '../actions/ConversationsTaxonomyActions';
import { fetchStatus } from '../utils/api/ConversationsTaxonomyApi';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ConversationsTaxonomyPanel = ({
  threadId,
  onClose
}) => {
  const dispatch = useDispatch();
  const [threadStatus, setThreadStatus] = useState('');
  useEffect(() => {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | number | true | { [prop... Remove this comment to see the full error message
    fetchStatus(threadId).then(response => setThreadStatus(response || ''));
  }, [threadId]);
  useEffect(() => {
    dispatch(fetchPropertiesMeta());
  }, [dispatch]);
  useEffect(() => {
    dispatch(fetchPropertiesForThread(threadId));
    dispatch(resolveUpdatePropertyError());
  }, [dispatch, threadId]);
  const propertiesMeta = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseCrmComponents' does not exist on ty... Remove this comment to see the full error message
  ({
    zorseCrmComponents: state
  }) => state.propertiesMeta);
  const threadRecord = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseCrmComponents' does not exist on ty... Remove this comment to see the full error message
  ({
    zorseCrmComponents: state
  }) => state.threadProperties);
  const propertyUpdateStatus = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseCrmComponents' does not exist on ty... Remove this comment to see the full error message
  ({
    zorseCrmComponents: state
  }) => state.propertyUpdateStatus);
  const actionStates = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseCrmComponents' does not exist on ty... Remove this comment to see the full error message
  ({
    zorseCrmComponents: state
  }) => state.actionStates);
  const patchPropertyChange = property => {
    dispatch(setPropertyForThread(threadId, property, threadRecord));
  };
  const markAsGhosted = checked => {
    dispatch(markThreadAsGhosted(threadId, checked));
  };
  const isThreadCloseable = () => {
    return threadStatus !== 'ENDED' && (threadRecord.hasAllRequiredProperties() || threadRecord.ghosted);
  };
  return /*#__PURE__*/_jsxs(UIPanel, {
    width: 320,
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      className: "m-right-3",
      onClick: () => {
        onClose();
      }
    }), /*#__PURE__*/_jsx(UIPanelHeader, {
      children: /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.taxonomy.panel.header"
        })
      })
    }), /*#__PURE__*/_jsx(UIPanelBody, {
      className: "p-all-5",
      children: /*#__PURE__*/_jsx(ConversationsTaxonomy, {
        displayMode: "panel",
        markAsGhosted: markAsGhosted,
        onPropertyChange: patchPropertyChange,
        propertiesMeta: propertiesMeta,
        propertyUpdateStatus: propertyUpdateStatus,
        threadId: threadId,
        threadRecord: threadRecord
      })
    }), /*#__PURE__*/_jsxs(UIPanelFooter, {
      className: "p-all-6",
      children: [/*#__PURE__*/_jsx(UILoadingButton, {
        disabled: !isThreadCloseable(),
        failed: actionStates.hasError,
        loading: actionStates.isSavingThread,
        use: "primary",
        onClick: () => dispatch(closeThread(threadId, threadRecord)).then(action => !action.error && onClose()),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.taxonomy.panel.footer.close"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "secondary",
        onClick: () => {
          Track.cancelClicked();
          onClose();
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.taxonomy.panel.footer.cancel"
        })
      })]
    })]
  });
};
ConversationsTaxonomyPanel.propTypes = {
  threadId: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired
};
export default ConversationsTaxonomyPanel;